'use client';

import React from 'react';
import Text from '@components/atoms/Text';
import Image from 'next/image';
import styles from './ContentSection.module.scss';
import assetLoader from '@utils/internalImageLoder';
import { useIsMobile } from '@hooks/use-mobile';
import Button from '@components/atoms/Button';
import { useRouter } from 'next/navigation';
import { useGlobalLoader } from '@hooks/useGlobalLoader';
import VideoModalWrapper from '@components/molecules/VideoModalWrapper';
import { getLoginUrl } from '@utils/getLoginUrl';
import { getMonthFromDate } from '@helpers/dateFormatter';

const ContentSection = ({ cityName, activeCampaignData, completedCampaignData, isUserParticipated }: any) => {

    const router = useRouter();
    const isMobile = useIsMobile();
    const { showLoader } = useGlobalLoader();

    const metaData = {
        authorName: "ACKO DRIVE",
        authorType: "ACKO DRIVE",
        duration: "127",
        mediaSource: "S3",
        primaryText: "ACKO Drive Car Drop Winner",
        secondaryText: "",
        thumbnail: `${assetLoader()}/images/winnerThumbnail.png`,
        title: "ACKO Drive Car Drop Winner",
    };

    const videoUrl = "https://ackodrive-prod.ackoassets.com/video/generic/nov_car_drop_winner_vertical.m3u8";

    const handleButtonClick = () => {
        showLoader();
        router.push('/car-drop/?hide_app_bar=true');
    }

    return (
        <>
            <div className={styles.CDWinnerDeclarationTopSection}>
                <div className={styles.WDHeadSectionContent}>
                    <Text className={styles.WDHeadSectionContentTitle}>Presenting our</Text>
                    <Text className={styles.WDHeadSectionContentSubTitle}>{completedCampaignData?.metadata?.productRevealDate ? getMonthFromDate(completedCampaignData?.metadata?.productRevealDate) : ''} Car Drop Winner</Text>
                    <Image
                        src={`${assetLoader()}/images/mahindraRevealImage.png`}
                        alt='arrow icon'
                        fill
                        loading='eager'
                        className={styles.carRevealName}
                    />
                </div>
                <div className={styles.CDWinnerDecQuote}>
                    <Text className={styles.CDWinnerDecQuoteDesp}>Abhi tak believe nahi ho raha! When I got the call, I thought someone was joking. Winning the BE 6 feels like a dream come true yaar, ekdum unbelievable!</Text>
                    <Text className={styles.CDWinnerDecQuoteName}>Sandeep Kumar, winner</Text>
                </div>
            </div>
            <div className={styles.CWDpriceSection}>
                <div className={styles.CWDpriceSectionTitleContainer}>
                    <Image
                        src={`${assetLoader()}/icons/campaignStart.svg`}
                        alt="campaignStart"
                        width={26}
                        height={26}
                        className={styles.campaignStartIcon}
                    />
                    <Text className={styles.CWDpriceSectionTitle}>The prizes don&apos;t stop there</Text>
                    <Image
                        src={`${assetLoader()}/icons/campaignStart.svg`}
                        alt="campaignStart"
                        width={26}
                        height={26}
                        className={styles.campaignStartIcon}
                    />
                </div>
                <Text className={styles.CWDpriceSectionHeading}>More rewards for {completedCampaignData?.metadata?.productRevealDate ? getMonthFromDate(completedCampaignData?.metadata?.productRevealDate) : ''} participants.</Text>
                <Image
                    src={`${assetLoader()}/images/${isMobile ? 'priceImageMobile' : 'priceImageDesktop'}.png`}
                    alt="About AD Car Drop"
                    fill
                    loading='lazy'
                    className={styles.CWDpriceSectionImage}
                />
                <Text className={styles.CWDpriceSectionDesp}>Valid for Express delivery car bookings on ACKO Drive made between 1st-31st Dec 2025.</Text>
            </div>
            <div className={activeCampaignData && activeCampaignData?.status === "ACTIVE" ? styles.CWDHearFromWinner : styles.CWDHearFromWinnerNoMargin}>
                <Text className={styles.HearFromWinnerHeading}>Hear from our winner</Text>
                <VideoModalWrapper cityName={cityName} metaData={metaData} videoUrl={videoUrl}>
                    <Image
                        src={`${assetLoader()}/images/${isMobile ? 'HearFromWinnerVideoMobile' : 'HearFromWinnerVideoDesktop'}.png`}
                        alt="campaignStart"
                        fill
                        className={styles.HearFromWinnerVideoImage}
                    />
                </VideoModalWrapper>
            </div>

            {
                activeCampaignData && activeCampaignData?.status === "ACTIVE" &&
                <div className={styles.liveModalContainer}>
                    <div className={styles.liveModalContent}>
                        <video
                            src={`${assetLoader()}/BCR_new_video.webm`}
                            className={styles.liveModalContentImage}
                            autoPlay
                            loop
                            muted
                            playsInline
                            preload="auto"
                        />
                        <div className={styles.liveModalInnerContent}>
                            <Image
                                src={`${assetLoader()}/images/CarDropLogo.svg`}
                                alt='arrow icon'
                                fill
                                loading='eager'
                                className={styles.liveModalInnerContentImage}
                            />
                            <div className={styles.liveModalInnerContentLive}>
                                <Text className={styles.liveModalInnerContentLiveText}>{activeCampaignData?.metadata?.productRevealDate ? getMonthFromDate(activeCampaignData?.metadata?.productRevealDate) : 'New'} edition is</Text>
                                <div className={styles.liveModalInnerContentLiveContainer}>
                                    <div className={styles.liveModalInnerContentLiveGreen} />
                                    <Text className={styles.liveModalInnerContentLiveContainerText}>Live</Text>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Button
                        className={styles.liveModalContentButton}
                        onClick={handleButtonClick}
                    >
                        {
                            isUserParticipated ? 'View your entry details' : `Join the ${activeCampaignData?.metadata?.productRevealDate ? getMonthFromDate(activeCampaignData?.metadata?.productRevealDate) : ''} Car Drop`
                        }
                    </Button>
                </div>
            }
        </>
    )
}

export default ContentSection